import { BuildClass, Do } from '../../../universal';
import { React, _ } from '../../lib';
import { List } from './list';
import { ConditionalObject, useStateSync } from './meta-types';
import { ResizeSplitter } from './resize-split';
import { stubResizeSplitterInstance } from './stubs';
const DEFAULT_WIDTH = 160;
const SidebarControlCmpt = (props, ref) => {
    const [value, setValue] = React.useState(props.value);
    useStateSync({
        stateVal: value,
        propVal: props.value,
        setState: setValue,
        setProp: props.onUpdate,
        compareFn: (a, b) => a == b,
    });
    const [widths, setWidths] = React.useState(props.widths);
    useStateSync({
        propVal: props.widths,
        stateVal: widths,
        setProp: props.onUpdateWidths ?? _.noop,
        setState: setWidths,
    });
    const buildClass = BuildClass({
        'ui5-sidebar': true,
        [props.className ?? '']: true,
    });
    const buildSidebar = (React.createElement(List, { className: "sidebar", value: value, onUpdate: setValue, multiple: false, height: 30, rows: _.compact([
            ConditionalObject(Boolean(props.newLabel), {
                value: -1,
                className: 'new',
                height: 41,
                content: () => React.createElement("div", { className: "new-inner" }, props.newLabel),
            }),
            ...props.items.map(x => ({
                value: x.value,
                className: x.className,
                content: () => props.onDelete != null && (x.deletable ?? false) ? (React.createElement("div", { className: "flex" },
                    React.createElement("span", { className: "flex-1 max-w-[calc(100%-16px)] text-ellipsis overflow-hidden" }, x.text),
                    React.createElement("span", { className: "flex-1 max-w-4 max-h-4 hover:bg-red-400" },
                        React.createElement("img", { src: "/static/img/i8/color-trash-delete.svg", alt: "Delete Item", onClick: e => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (props.onDelete == null) {
                                    console.error('Cannot delete item without onDelete function');
                                    return;
                                }
                                props.onDelete(x.value);
                            } })))) : (React.createElement(React.Fragment, null, x.text)),
            })),
        ]) }));
    const buildForm = Do(() => {
        if (value || props.showFormOnNull) {
            return props.buildForm(value);
        }
        else if (props.stubMessage != null) {
            return (React.createElement("div", { className: "stub-message-wrapper" },
                React.createElement("div", { className: "stub-message" }, props.stubMessage)));
        }
        return React.createElement("div", null);
    });
    const elRef = React.useRef(stubResizeSplitterInstance);
    React.useImperativeHandle(ref, () => ({
        getElement: () => elRef.current.getElement(),
        getResizeSplitter: () => elRef.current,
    }));
    return (React.createElement(ResizeSplitter, { value: widths, onUpdate: setWidths, className: buildClass, ref: elRef, panes: [
            {
                defaultWidth: props.pane?.defaultWidth ?? props.width ?? DEFAULT_WIDTH,
                minWidth: props.pane?.minWidth ?? props.minWidth ?? DEFAULT_WIDTH,
                maxWidth: props.pane?.maxWidth ?? null,
                flexWidth: null,
                collapsible: props.pane?.collapsible ?? false,
                content: buildSidebar,
            },
            {
                defaultWidth: null,
                minWidth: null,
                maxWidth: null,
                flexWidth: 1,
                collapsible: false,
                content: React.createElement("div", { className: "ui5-sidebar-form" }, buildForm),
            },
        ] }));
};
export const SidebarControl = React.forwardRef(SidebarControlCmpt);
//# sourceMappingURL=sidebar.js.map